import 'scroll-behavior-polyfill';
import {} from 'jquery-ujs';
import './services/alert';
import './services/dropdown';
import './services/modal';
import './services/modal_content';
import '../design-system/services/selector';
import '@hotwired/turbo-rails';

Turbo.session.drive = false;

$(document).on('change', 'form[data-autosubmit]', e => {
  e.target.form.requestSubmit();
});

$(document).on('turbo:frame-render', (e) => {
  $(document).trigger('dom-update', e.target);
});

$(document).on('turbo:load', () => {
  $(document).trigger('dom-update');
});
